import { useCallback, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { MyWeek } from "../ui";
import { sleep } from "../../helpers";

export const useScheduleConfig = ({ scheduleEvents }) => {
  const { message } = useSelector((state) => state.patient.formEvent);

  const [currentView, setCurrentView] = useState("week");
  const [currentNavigate, setCurrentNavigate] = useState(null);
  const [isSelectSlotModal, setIsSelectSlotModal] = useState(false);

  const isMobile = useMemo(() => window.innerWidth < 768, []);
  const { views } = useMemo(
    () => ({
      views: {
        month: true,
        week: MyWeek,
        day: true,
      },
    }),
    []
  );

  const eventPropGetter = (event) => {
    return {
      className:
        event.state === "BUSY"
          ? "bg-primary"
          : event.state === "FREE"
          ? "bg-success"
          : "bg-primary",
    };
  };

  const waitForScrollToSettle = (timeout = 1000, threshold = 2) => {
    return new Promise((resolve) => {
      let lastY = window.scrollY;
      let sameCount = 0;
      let start = performance.now();

      const check = (time) => {
        const currentY = window.scrollY;
        if (Math.abs(currentY - lastY) <= threshold) {
          sameCount++;
        } else {
          sameCount = 0;
        }

        if (sameCount > 5 || time - start > timeout) {
          resolve();
        } else {
          lastY = currentY;
          requestAnimationFrame(check);
        }
      };

      requestAnimationFrame(check);
    });
  };

  const scrollToFirstEvent = useCallback(async () => {
    if (currentView === "week" || currentView === "day") {
      await sleep(150);
      const firstEventEl = document.querySelector(".rbc-event");

      if (firstEventEl) {
        firstEventEl.focus();
        firstEventEl.scrollIntoView({ behavior: "smooth", block: "start" });

        await waitForScrollToSettle();

        if (message?.text === "get schedule successfully") {
          setIsSelectSlotModal(true);
        }
      }
    }
  }, [currentView, message]);

  useEffect(() => {
    scrollToFirstEvent();
  }, [currentView, currentNavigate, scheduleEvents]);

  return {
    // Props
    isMobile,
    views,
    isSelectSlotModal,

    // Methods
    eventPropGetter,
    setCurrentView,
    setCurrentNavigate,
    setIsSelectSlotModal,
  };
};
